/**
 * Reusable CTA popup.
 *
 * Usage:
 *   CtaPopup.show();                       // default post-order content
 *   CtaPopup.show({ title, subtitle, cards, onCardClick });
 *   CtaPopup.hide();
 *
 * The popup is presentation only. It reports the clicked card through the
 * onCardClick callback and the "cta-popup:card-click" event on document, then
 * leaves the decision of what happens next to the caller.
 *
 * Card shape: { id, image, title, description, ctaLabel, href, external, hasCommentBox }
 */
(function () {
  var MEDIA_ICONS = {
    gift:
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M20 12V22H4V12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M22 7H2V12H22V7Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M12 22V7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    thumb:
      '<svg width="28" height="28" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M21.711 8.07704H13.8484L12.1202 1.5993C11.8112 0.644322 10.9413 0 9.93419 0H6.11159V8.07704H0V23H18.1631C19.0787 23 19.9027 22.4477 20.2461 21.6538L23.8169 14.1981C23.9428 13.9105 24 13.5998 24 13.2891V10.3897C24 9.12406 22.97 8.08854 21.711 8.08854V8.07704ZM6.11159 20.6989H2.28898V10.3782H6.11159V20.6989ZM18.1631 20.6989H8.40057V2.27814L9.92275 2.25513L12.0858 10.3782H21.711L21.7339 13.2431L18.1631 20.7104V20.6989Z" fill="currentColor"/>' +
      '</svg>',
    heart:
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/>' +
      '</svg>',
    star:
      '<svg class="cta-popup__stars-icon" width="72" height="14" viewBox="0 0 72 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M7 1L8.6 4.8L12.6 5.2L9.6 7.8L10.5 11.8L7 9.8L3.5 11.8L4.4 7.8L1.4 5.2L5.4 4.8L7 1Z" fill="currentColor"/>' +
      '<path d="M21 1L22.6 4.8L26.6 5.2L23.6 7.8L24.5 11.8L21 9.8L17.5 11.8L18.4 7.8L15.4 5.2L19.4 4.8L21 1Z" fill="currentColor"/>' +
      '<path d="M35 1L36.6 4.8L40.6 5.2L37.6 7.8L38.5 11.8L35 9.8L31.5 11.8L32.4 7.8L29.4 5.2L33.4 4.8L35 1Z" fill="currentColor"/>' +
      '<path d="M49 1L50.6 4.8L54.6 5.2L51.6 7.8L52.5 11.8L49 9.8L45.5 11.8L46.4 7.8L43.4 5.2L47.4 4.8L49 1Z" fill="currentColor"/>' +
      '<path d="M63 1L64.6 4.8L68.6 5.2L65.6 7.8L66.5 11.8L63 9.8L59.5 11.8L60.4 7.8L57.4 5.2L61.4 4.8L63 1Z" fill="currentColor"/>' +
      '</svg>',
    comment:
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M21 12C21 16.4 16.97 20 12 20C10.6 20 9.3 19.7 8.14 19.2L3 21L4.9 16.6C3.7 15.4 3 13.8 3 12C3 7.6 7.03 4 12 4C16.97 4 21 7.6 21 12Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
  };

  var DEFAULT_CONFIG = {
    title: 'Sending your order to our chefs!',
    subtitle: '',
    cards: [
      {
        id: 'refer-a-friend',
        textMedia: true,
        mediaIcon: 'gift',
        title: 'REFER A FRIEND',
        description: 'Give a friend £10 off and get £10 credit!',
        ctaLabel: 'REFER A FRIEND'
      },
      {
        id: 'meal-rating',
        textMedia: true,
        mediaIcon: 'thumb',
        title: 'RATE YOUR MEALS',
        description: 'Let us know what you think about your latest meals!',
        ctaLabel: 'RATE YOUR MEALS'
      },
      {
        id: 'preferences',
        textMedia: true,
        mediaIcon: 'heart',
        title: 'SELECT YOUR PREFERENCES',
        description: 'Lock in your favourites for future orders!',
        ctaLabel: 'CHOOSE PREFERENCES'
      },
      {
        id: 'leave-review',
        textMedia: true,
        mediaIcon: 'star',
        title: 'LEAVE US A REVIEW',
        description: 'Tell others why you love FuelHub.',
        ctaLabel: 'LEAVE A REVIEW'
      }
    ]
  };

  function CtaPopup() {
    this.root = null;
    this.cards = [];
    this.onCardClick = null;
    this.lastFocused = null;
  }

  CtaPopup.prototype.init = function () {
    if (this.root) return true;

    this.root = document.getElementById('cta-popup');
    if (!this.root) return false;

    this.titleEl = this.root.querySelector('[data-cta-popup-title]');
    this.subtitleEl = this.root.querySelector('[data-cta-popup-subtitle]');
    this.gridEl = this.root.querySelector('[data-cta-popup-grid]');

    var self = this;

    this.root.addEventListener('click', function (event) {
      if (event.target.closest('[data-cta-popup-dismiss]')) {
        self.hide();
        return;
      }

      var cardEl = event.target.closest('[data-cta-popup-card]');
      if (cardEl && event.target.closest('.cta-popup__card-cta')) {
        self.handleCardClick(cardEl);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.isOpen()) self.hide();
    });

    return true;
  };

  CtaPopup.prototype.isOpen = function () {
    return !!this.root && this.root.classList.contains('is-open');
  };

  CtaPopup.prototype.buildCard = function (card, index) {
    var article = document.createElement('article');
    article.className = 'cta-popup__card';
    article.setAttribute('data-cta-popup-card', card.id || String(index));

    var usesTextMedia = !!(card.textMedia || (!card.image && card.title));

    if (usesTextMedia) {
      var textMedia = document.createElement('div');
      textMedia.className = 'cta-popup__card-media cta-popup__card-media--text';
      if (card.mediaIcon && MEDIA_ICONS[card.mediaIcon]) {
        textMedia.className += ' cta-popup__card-media--with-icon';
      }
      textMedia.setAttribute('aria-hidden', 'true');

      if (card.mediaIcon && MEDIA_ICONS[card.mediaIcon]) {
        var iconWrap = document.createElement('span');
        iconWrap.className = 'cta-popup__card-media-icon';
        iconWrap.innerHTML = MEDIA_ICONS[card.mediaIcon];
        textMedia.appendChild(iconWrap);
      }

      var textMediaLabel = document.createElement('span');
      textMediaLabel.className = 'cta-popup__card-media-label';
      textMediaLabel.textContent = card.mediaLabel || card.title || '';
      textMedia.appendChild(textMediaLabel);

      article.appendChild(textMedia);
    } else if (card.image) {
      var media = document.createElement('div');
      media.className = 'cta-popup__card-media';

      var image = document.createElement('img');
      image.className = 'cta-popup__card-image';
      image.src = card.image;
      image.alt = card.title || '';
      image.loading = 'lazy';

      media.appendChild(image);
      article.appendChild(media);
    }

    var body = document.createElement('div');
    body.className = 'cta-popup__card-body';

    if (!usesTextMedia) {
      var title = document.createElement('h3');
      title.className = 'cta-popup__card-title';
      title.textContent = card.title || '';
      body.appendChild(title);
    } else {
      // Keep an accessible title for screen readers when the visual title is in the media.
      var srTitle = document.createElement('h3');
      srTitle.className = 'cta-popup__card-title visually-hidden';
      srTitle.textContent = card.title || '';
      body.appendChild(srTitle);
    }

    if (card.description) {
      var text = document.createElement('p');
      text.className = 'cta-popup__card-text';
      text.textContent = card.description;
      body.appendChild(text);
    }

    if (card.hasCommentBox) {
      article.classList.add('cta-popup__card--comment');

      var textarea = document.createElement('textarea');
      textarea.className = 'cta-popup__comment-input';
      textarea.setAttribute('data-cta-comment-input', '');
      textarea.setAttribute('rows', '4');
      textarea.setAttribute('maxlength', '1000');
      textarea.placeholder = 'Write your comment here…';
      textarea.setAttribute('aria-label', 'Comment');
      body.appendChild(textarea);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn--outline btn--white cta-popup__card-cta';
    button.textContent = card.ctaLabel || 'CTA';
    body.appendChild(button);

    article.appendChild(body);
    return article;
  };

  CtaPopup.prototype.render = function (config) {
    this.titleEl.textContent = config.title || '';
    this.subtitleEl.textContent = config.subtitle || '';
    this.subtitleEl.style.display = config.subtitle ? '' : 'none';

    this.gridEl.innerHTML = '';
    this.gridEl.classList.toggle('cta-popup__grid--single', this.cards.length === 1);

    var self = this;
    this.cards.forEach(function (card, index) {
      self.gridEl.appendChild(self.buildCard(card, index));
    });
  };

  CtaPopup.prototype.show = function (options) {
    if (!this.init()) return;

    var config = options || {};

    this.cards = config.cards || DEFAULT_CONFIG.cards;
    this.onCardClick = typeof config.onCardClick === 'function' ? config.onCardClick : null;

    this.render({
      title: config.title !== undefined ? config.title : DEFAULT_CONFIG.title,
      subtitle: config.subtitle !== undefined ? config.subtitle : DEFAULT_CONFIG.subtitle
    });

    this.lastFocused = document.activeElement;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cta-popup-open');

    var closeButton = this.root.querySelector('.cta-popup__close');
    if (closeButton) closeButton.focus();

    document.dispatchEvent(new CustomEvent('cta-popup:show'));
  };

  CtaPopup.prototype.hide = function () {
    if (!this.root) return;

    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cta-popup-open');

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }

    document.dispatchEvent(new CustomEvent('cta-popup:hide'));
  };

  CtaPopup.prototype.handleCardClick = function (cardEl) {
    var index = Array.prototype.indexOf.call(this.gridEl.children, cardEl);
    var card = this.cards[index];
    if (!card) return;

    var comments = '';
    var input = cardEl.querySelector('[data-cta-comment-input]');
    if (input) comments = String(input.value || '').trim();

    var detail = { card: card, id: card.id, index: index, comments: comments };

    if (this.onCardClick) this.onCardClick(card, index, detail);
    document.dispatchEvent(new CustomEvent('cta-popup:card-click', { detail: detail }));
  };

  window.CtaPopup = new CtaPopup();

  // Temporary preview trigger: append ?cta_popup=1 to any URL to review the UI.
  document.addEventListener('DOMContentLoaded', function () {
    if (new URLSearchParams(window.location.search).has('cta_popup')) {
      window.CtaPopup.show({
        onCardClick: function (card) {
          console.log('[CtaPopup] card clicked:', card.id);
        }
      });
    }
  });
})();
